const infiniteScroll = require('vue-infinite-scroll')

const InfiniteScroll = {
    install(Vue) {
        Vue.use(infiniteScroll)
    }
}

export default InfiniteScroll
